"use client";
import type { FC } from "react";
import { requestIdleCallbackCompat } from "../requestIdle";
import type { IconProps } from "./OspIcons";
import iconMap from "./fonts/Ospicons.json";
import { useStyles } from "./style";

/**
 * 字体加载器（方案A：纯 WOFF2）
 * 
 * 策略：
 * - 使用完整的 WOFF2 字体 (~128KB，包含所有 1409 个图标)
 * - 零风险：所有图标都可用，包括动态加载的图标
 * - 零维护：无需扫描、分析、子集化
 * 
 * 性能优化：
 * - 文件大小：367KB → 128KB (-65%)
 * - 格式优化：WOFF2 压缩，比 TTF 小 60-70%
 * - 加载优化：延迟加载，不阻塞首屏
 * - 降级方案：WOFF2 → TTF 自动降级
 */
const fontLoader = {
  loaded: false as boolean,
  loading: false as boolean,
  
  async load(): Promise<void> {
    if (fontLoader.loaded || fontLoader.loading) { 
      return; 
    }
    
    fontLoader.loading = true;
    
    try {
      // 使用 WOFF2 压缩格式（优先），降级到 TTF
      // WOFF2: 128KB (97% 浏览器支持)
      // TTF: 367KB (100% 浏览器支持，降级方案)
      // const face = new (window as any).FontFace(
      //   'OspIcons',
      //   'url(/OspIcons.woff2) format("woff2"), url(/OspIcons.ttf) format("truetype")',
      // );
      // const loaded = await face.load();
      // (document as any).fonts.add(loaded);

      // 项目使用next/font/local来加载字体，所以这里不需要加载字体, next/font/local会预加载字体
      fontLoader.loaded = true;
    } catch (error) {
      // Failed to load OspIcons font
    } finally {
      fontLoader.loading = false;
    }
  },
};

// 全局自动预加载：在浏览器空闲时加载字体
if (typeof window !== 'undefined') {
  const preloadFont = () => {
    fontLoader.load().catch(() => {
      // Silently fail
    });
  };
  
  requestIdleCallbackCompat(preloadFont, { timeout: 2000 });
}


export const Icon: FC<IconProps> = ({
	name,
	size = 16,
	color,
	className = "",
	onClick,
  style,
  ...props
}) => {
	const { styles, cx } = useStyles();
  // const [isFontLoaded, setIsFontLoaded] = useState(fontLoader.loaded);
  
  // 从 json 文件中获取 icon 对应的 unicode
  const unicode = (iconMap as Record<string, number>)[name];
  
  // useEffect(() => {
  //   if (!isFontLoaded) {
  //     fontLoader
  //       .load()
  //       .then(() => setIsFontLoaded(true))
  //       .catch(() => setIsFontLoaded(false));
  //   }
  // }, [isFontLoaded]);
  
  if (!unicode) {
    return null;
  }

	// if (!isFontLoaded) {
	// 	// 显示占位符，避免布局偏移
	// 	return (
  //     <span 
  //       className={className}
  //       style={{ 
  //         width: size, 
  //         height: size, 
  //         display: 'inline-block',
  //         ...style,
  //       }} 
  //     />
  //   );
	// }

	return (
		<span
			className={cx(styles.font, className)}
			onClick={onClick}
			style={{
				fontSize: size,
				color: color,
        ...style,
			}}
      {...props}
		>
			{String.fromCodePoint(unicode)}
		</span>
	);
};

export const getIconUnicode = (name: string) => {
  const unicode = (iconMap as Record<string, number>)[name];
  return unicode ? String.fromCodePoint(unicode) : "";
};